export default __webpack_public_path__ + "static/media/home_retail_cover.755eb609.png";